module.exports = __webpack_public_path__ + "img/ipad-cover.0dfec16e.png";